import { createSlice } from "@reduxjs/toolkit";
import { CheckoutInitialStore } from "./types.store";
import {
  handleGetCheckoutItemsRequest,
  handleGetScheduledCheckoutItemsRequest,
} from "./thunk.store";

const initialState: CheckoutInitialStore = {
  checkoutItems: [],
  pagination: {
    count: 0,
    totalCount: 0,
    hasMore: false,
  },
};

const CheckoutStore = createSlice({
  initialState,
  name: "checkoutData",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      handleGetCheckoutItemsRequest.fulfilled,
      (state, action) => {
        state.checkoutItems = action.payload;
      },
    );
    builder.addCase(
      handleGetScheduledCheckoutItemsRequest.fulfilled,
      (state, action) => {
        const { offset = 0 } = action.meta.arg;
        const newItems = action.payload.items;

        // Se offset é 0, substitui a lista (primeira carga)
        if (offset === 0) {
          state.checkoutItems = newItems;
        } else {
          // Anexa apenas itens que não existem na lista (evita duplicatas)
          const existingIds = new Set(
            state.checkoutItems.map((item) => item.id),
          );
          const uniqueNewItems = newItems.filter(
            (item) => !existingIds.has(item.id),
          );
          state.checkoutItems = [...state.checkoutItems, ...uniqueNewItems];
        }
        state.pagination = action.payload.pagination;
      },
    );
  },
});

export default CheckoutStore.reducer;
